export abstract class Condition {
  protected _target: any
  abstract get result(): boolean;
  abstract get paths(): Array<string>
}
